import React from "react"

import profilePic from "../../../assets/images/profile.jpg"

import "../../_common/common.css"
import "./about.css"

import ReactGA from "react-ga"

const About = () => {
  const onLinkClick = () => {
    ReactGA.event({
      category: "User",
      action: "Click on CV"
    })
  }

  return (
    <div className="home-section container-about">
      <img
        className="profile-picture-about"
        alt="profilepic"
        src={profilePic}
      />
      <div className="about-text">
        <div className="about-text-main">
          Hi, I'm Artsem
        </div>
        <br />
        Accomplished Frontend Engineer at{" "}
          <a
            href="https://www.guru.com/freelancers/arciom-kananovich/"
            style={{ fontSize: "1.2em" }}
          >
            Guru
          </a> with experience creating visually stunning and user-friendly SaaS applications that delight users and drive business growth. My passion for software development as a creative endeavor, coupled with my extensive knowledge of engineering and design principles, enables me to build elegant solutions that exceed expectations.
        <br />
        If you want to know more:{" "}
        <a
          onClick={onLinkClick}
          href="https://docs.google.com/document/d/1GvZ9hDrcvL-pJarG-oqZqs7QI1OzJaPIP7SoGnSGWN4/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="about-cv">HERE is my Resume.</span>
        </a>
        <br />
        <br />
        Keep scrolling to see some of the projects I've worked on.
      </div>
    </div>
  )
}

export default About
